// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const UnifiedInvoiceList    = lazy(() => import('../../views/unifiedInvoice/list'))

const UnifiedInvoice = [
  {
    path: '/unifiedInvoice/list',
    element: <UnifiedInvoiceList />
  }
]

export default UnifiedInvoice